
import { useState, useCallback, useEffect } from "react";
import { PendingAction } from "@/types/movie";
import { logState } from "@/utils/debugLogger";

/**
 * Hook for managing card visual state (hover states, visual properties)
 */
export const useCardVisualState = (
  movieTitle: string,
  pendingAction: PendingAction | undefined,
  shouldDebug: boolean
) => {
  const [hovered, setHovered] = useState(false);
  
  // Calculate remaining time for the pending action
  const getRemainingTime = useCallback(() => {
    if (!pendingAction) return 0;
    const elapsed = Date.now() - pendingAction.timestamp;
    return Math.max(0, 3000 - elapsed); // Use UNDO_DURATION (3000ms)
  }, [pendingAction]);

  // Log state changes when hovered state changes
  useEffect(() => {
    if (shouldDebug && hovered) {
      logState(`Movie card hovered: ${movieTitle}`, { 
        hasPendingAction: !!pendingAction 
      });
    }
  }, [hovered, movieTitle, pendingAction, shouldDebug]);

  return {
    hovered,
    setHovered,
    getRemainingTime
  };
};
